<!--
  - Copyright (c) 2022.
  - ISNLab
  - Owner and rewriter: Sedov A. Sergey
  - sedov.sergey@isnlab.com
  -->

<template>
  <div class="app-content pt-3 p-md-3 p-lg-4">
<!--    <div class="container-xl pt-5" v-if="isLoading">
      <span class="cssload-loader"><span class="cssload-loader-inner"></span></span>
    </div>-->
    <div class="container-xl">

      <h1 class="app-page-title">Stream: {{currentStream?.description}}</h1>

      <ErrorBlock></ErrorBlock>


      <div class="row g-4 mb-4">
        <div class="col">
          <div class="app-card app-card-stat shadow-sm h-100">
            <LineLoading :loading="isLoading"></LineLoading>
            <div class="app-card-body p-3 p-lg-4">
              <h4 class="stats-type mb-1">Stream Balance</h4>
              <Transition>
                <div class="stats-figure text-primary" v-if="!isLoading">{{availableToWithdraw}}</div>
              </Transition>
              <div class="stats-meta">Available for withdrawal</div>
            </div><!--//app-card-body-->
            <a class="app-card-link-mask" href="#"></a>
          </div><!--//app-card-->
        </div><!--//col-->
        <div class="col">
          <div class="app-card app-card-stat shadow-sm h-100">
            <LineLoading :loading="isLoading"></LineLoading>
            <div class="app-card-body p-3 p-lg-4">
              <h4 class="stats-type mb-1">Total Stream Earnings</h4>
              <Transition>
              <div class="stats-figure" v-if="!isLoading">{{totalEarnings}}</div>
              </Transition>
              <div class="stats-meta">Only events</div>
            </div><!--//app-card-body-->
            <a class="app-card-link-mask" href="#"></a>
          </div><!--//app-card-->
        </div><!--//col-->
        <div class="col">
          <div class="app-card app-card-stat shadow-sm h-100">
            <LineLoading :loading="isLoading"></LineLoading>
            <div class="app-card-body p-3 p-lg-4">
              <h4 class="stats-type mb-1">Clicks / Conversions</h4>
              <Transition>
                <div class="stats-figure" v-if="!isLoading">{{clicks}} / {{stat.events || 0}}</div>

              </Transition>
              <div class="stats-meta">Earnings</div>
            </div><!--//app-card-body-->
            <router-link class="app-card-link-mask" :to="{name:'Earnings'}"></router-link>
          </div><!--//app-card-->
        </div><!--//col-->
        <div class="col">
          <div class="app-card app-card-stat shadow-sm h-100">
            <LineLoading :loading="isLoading"></LineLoading>
            <div class="app-card-body p-3 p-lg-4">
              <h4 class="stats-type mb-1">Click Rate (CR)</h4>
              <Transition>
                <div class="stats-figure" v-if="!isLoading">{{stat.cr || 0}} %</div>
              </Transition>
            </div><!--//app-card-body-->
            <a class="app-card-link-mask" href="#"></a>
          </div><!--//app-card-->
        </div><!--//col-->
        <div class="col-auto">
          <div class="app-card app-card-stat shadow-sm h-100">
            <div class="app-card-body p-3 p-lg-4">
              <h4 class="stats-type mb-1">eCPC</h4>
              <div class="stats-figure" v-if="!isLoading">{{ecpc}}</div>
            </div><!--//app-card-body-->
            <a class="app-card-link-mask" href="#"></a>
          </div><!--//app-card-->
        </div><!--//col-->

      </div><!--//row-->

<!--      <div class="row g-4 mb-4">
        <div class="col">
          <div class="app-card app-card-stat shadow-sm h-100">
            <LineLoading :loading="isLoading"></LineLoading>
            <div class="app-card-body p-3 p-lg-4">
              <h4 class="stats-type mb-1">Total Stream Earnings</h4>
              <Transition>
                <div class="stats-figure" v-if="!isLoading">{{totalEarnings}}</div>
              </Transition>
            </div>&lt;!&ndash;//app-card-body&ndash;&gt;
            <a class="app-card-link-mask" href="#"></a>
          </div>&lt;!&ndash;//app-card&ndash;&gt;
        </div>&lt;!&ndash;//col&ndash;&gt;
      </div>&lt;!&ndash;//col&ndash;&gt;-->

      <hr>

      <div class="row g-4 mb-4">
        <div class="col-12 col-lg-6">
          <div class="app-card app-card-chart h-100 shadow-sm">
            <div class="app-card-header p-3">
              <div class="row justify-content-between align-items-center">
                <div class="col-auto">
                  <h4 class="app-card-title">Income Traffic</h4>
                </div><!--//col-->
                <div class="col-auto">
                  <div class="card-header-action">
                    <router-link :to="{name:'Earnings'}">Earnings stat</router-link>
                  </div><!--//card-header-actions-->
                </div><!--//col-->
              </div><!--//row-->
            </div><!--//app-card-header-->
            <div class="app-card-body p-3 p-lg-4">

              <div class="chart-container">
                <LineChart :chartData="LineChartData" :options="options2"></LineChart>
              </div>
            </div><!--//app-card-body-->
          </div><!--//app-card-->
        </div><!--//col-->
        <div class="col-12 col-lg-6">
          <div class="app-card app-card-chart h-100 shadow-sm">
            <div class="app-card-header p-3">
              <div class="row justify-content-between align-items-center">
                <div class="col-auto">
                  <h4 class="app-card-title">Events relative stat</h4>
                </div><!--//col-->
                <div class="col-auto">
                  <div class="card-header-action">
                  </div><!--//card-header-actions-->
                </div><!--//col-->
              </div><!--//row-->
            </div><!--//app-card-header-->
            <div class="app-card-body p-3 p-lg-4">

              <div class="chart-container">
                  <DoughnutChart :chartData="DonutData" :options="options"></DoughnutChart>
              </div>
            </div><!--//app-card-body-->
          </div><!--//app-card-->
        </div><!--//col-->

      </div>

      <div class="row g-4 mb-4">
        <div class="col-12 col-lg-6">
          <div class="app-card shadow-sm border-left-decoration border-left-info h-100" role="alert">
            <div class="inner">
              <div class="app-card-body p-3 p-lg-4">
                <h3 class="mb-3">Earnings and Payments</h3>
                <div class="row gx-5 gy-3">
                  <div class="col-12">

                    <div>This is an overview of your generated earnings in Romance-net.com Dating Affiliate Program. Other items in the Statistics menu provide detailed data by Registrations (CPL),
                      First user payments (CPA) and Lifelong Revenue Share (all customer payments since the second one).
                    </div>
                  </div><!--//col-->
                </div><!--//row-->
              </div><!--//app-card-body-->

            </div><!--//inner-->
          </div><!--//app-card-->
        </div>
        <div class="col-12 col-lg-6">
          <div class="app-card app-card-orders-table shadow-sm mb-3 h-100">
            <div class="app-card-header p-3">
              <div class="row justify-content-between align-items-center">
              <div class="row justify-content-between align-items-center">
                <div class="col-auto">
                  <h4 class="app-card-title">Event statistic</h4>
                </div><!--//col-->
              </div><!--//row-->
            </div>
            <div class="app-card-body pb-3">
              <div class="table-responsive">
                <table class="table app-table-hover mb-0 text-left">
                  <thead>
                  <tr>
                    <th class="cell"></th>
                    <th class="cell text-info">Awaiting</th>
                    <th class="cell text-success">Accept</th>
                    <th class="cell text-danger">Reject</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td class="cell fwbold">Leads</td>
                    <td class="cell">{{stat.cpl_await}}</td>
                    <td class="cell">{{stat.cpl_accept}}</td>
                    <td class="cell">{{stat.cpl_reject}}</td>
                  </tr>


                  </tbody>
                </table>
              </div><!--//table-responsive-->

              <div class="table-responsive mt20">
                <table class="table app-table-hover mb-0 text-left">
                  <thead>
                  <tr>
                    <th class="cell"></th>
                    <th class="cell text-info">Leads</th>
                    <th class="cell text-info">CPAs</th>
                    <th class="cell text-info">Revshares</th>
                    <th class="cell text-info">Earned for events</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td class="cell fwbold">Total</td>
                    <td class="cell">{{stat.cpl}}</td>
                    <td class="cell">{{stat.cpa}}</td>
                    <td class="cell">{{stat.revshare}}</td>
                    <td class="cell">{{formatMoney(stat.earned)}}</td>
                  </tr>


                  </tbody>
                </table>
              </div><!--//table-responsive-->
            </div><!--//app-card-body-->
          </div>


        </div>

      </div>

    </div><!--//container-fluid-->
  </div>
  </div>
</template>

<script>
import {doLoading, isLoading, loadingDone, affiliateLink, currentStream} from "@/inc/storage";
import {Request} from "@/inc/client";
import LineLoading from "../components/ui/LineLoading";
import ErrorBlock from "../components/ui/ErrorBlock";
const numeral = require('numeral');
import { DoughnutChart, LineChart } from 'vue-chart-3';
import { Chart, registerables } from "chart.js";

window.chartColors = {
  green: '#75c181',
  gray: '#a9b5c9',
  text: '#252930',
  border: '#e7e9ed'
};
Chart.register(...registerables);

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "IndexPage",
  components: {ErrorBlock, LineLoading,LineChart, DoughnutChart},
  data() {
    return {
      fundsData : {
        available : 0,
        total_earned : 0,
      },
      stat : {
        cpl_await: 0,
        cpl_accept: 0,
        cpl_reject: 0,
        clicks : 0,
        earned : 0,
        cr : 0,
        events : 0,
        statuses : [],
      },
      weekClicks : [],
      prevClicks : [],

      DonutData : {
        labels: ['CPL', 'CPA', 'Revshare'],
        datasets: [
          {
            data: [95, 4, 1],
            backgroundColor: ['#0a964f', '#1ecb71', '#5b9379'],
          },
        ],
      },
      LineChartData : {
        labels: ['Day 1', 'Day 2', 'Day 3', 'Day 4', 'Day 5', 'Day 6', 'Day 7'],

        datasets: [{
          label: 'Last 7 days',
          fill: false,
          backgroundColor: window.chartColors.green,
          borderColor: window.chartColors.green,
          tension: 0.2,
          data: [0,0,0,0,0,0,0],
        }, {
          label: 'Previous 7 days',
          borderDash: [3, 5],
          backgroundColor: window.chartColors.gray,
          borderColor: window.chartColors.gray,
          tension: 0.2,
          data: [0,0,0,0,0,0,0],
          fill: false,
        }]
      },
      options : {
        responsive: true,
        aspectRatio: 1.6,
        cutout: 120,
        plugins: {
          legend: {
            position: 'top',
          },
        },
      },
      options2: {
        responsive: true,
        aspectRatio: 1.5,

        legend: {
          display: true,
          position: 'bottom',
          align: 'end',
        },

        tooltips: {
          mode: 'index',
          intersect: false,
          titleMarginBottom: 10,
          bodySpacing: 10,
          xPadding: 16,
          yPadding: 16,
          borderColor: window.chartColors.border,
          borderWidth: 1,
          backgroundColor: '#fff',
          bodyFontColor: window.chartColors.text,
          titleFontColor: window.chartColors.text,

          callbacks: {
            //Ref: https://stackoverflow.com/questions/38800226/chart-js-add-commas-to-tooltip-and-y-axis
            label: function(tooltipItem) {
              if (parseInt(tooltipItem.value) >= 1000) {
                return "$" + tooltipItem.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return '$' + tooltipItem.value;
              }
            }
          },

        },
        hover: {
          mode: 'nearest',
          intersect: true
        },
        scales: {
          x: {
            display: true,
            gridLines: {
              drawBorder: false,
              color: window.chartColors.border,
            },
          },
          y: {
            min: 0,
            beginAtZero: true,
            display: true,
            gridLines: {
              drawBorder: false,
              color: window.chartColors.border,
            },
            ticks: {
              userCallback: function(value) {
                return '$' + value.toLocaleString();   //Ref: https://stackoverflow.com/questions/38800226/chart-js-add-commas-to-tooltip-and-y-axis
              }
            },
          }
        }
      }
    }
  },
  setup() {
    return {
      isLoading, affiliateLink, currentStream
    }
  },
  mounted() {
    this.loadingData();
  },
  computed : {
    totalEarnings : function (){
      return numeral(this.stat.earned).format('$0,0.00');
    },
    availableToWithdraw : function (){
      return numeral(this.fundsData.available).format('$0,0.00');
    },
    ecpc : function (){
      return numeral(this.stat.ecpc).format('$0,0.00');
    },
    clicks : function (){
      return numeral(this.stat.clicks).format('0,0');
    },
  },
  methods: {
    formatMoney: function (value)
    {
      return numeral(value).format('$0,0.00');
    },
    loadingData: function () {
      let This = this
      doLoading()
      Request('dashboard', {params: {f:1}, method: 'GET'})
          .then(function (response) {
            This.fundsData = response.data.fundsData
            This.stat = response.data.stat
            //This.earnedStat = response.data.earnedStat
            This.LineChartData.datasets[0].data = response.data.weekClicks
            This.LineChartData.datasets[1].data = response.data.prevClicks
            This.DonutData.datasets[0].data = response.data.eventsCount
            console.log(response.data)
            loadingDone()
          })
    },
  }
}
</script>

<style scoped>

</style>